export const baseUrlManagement =
  process.env.NEXT_PUBLIC_API_URL_MANAGEMENT_SERVICE;
export const baseUrlAssets = process.env.NEXT_PUBLIC_API_URL_ASSET_SERVICE;
export const baseUrlUsers = process.env.NEXT_PUBLIC_API_URL_USER_SERVICE;
export const baseUrlCollaboration =
  process.env.NEXT_PUBLIC_API_URL_COLLABORATION_SERVICE;

const management = baseUrlManagement;
export const endpoints = {
  workspaces: `${management}/workspace`,
  projectById: (id: number): string => `${management}/project/${id}`,
  projectsGeography: `${management}/geography/projects`,
};
